<script lang="ts">
  import type { NestedList } from '../types';

  export let data: NestedList;
</script>

<svelte:element
  this="{data.style === 'unordered' ? 'ul' : 'ol'}"
  class="{data.style === 'unordered' ? 'list-disc' : 'list-decimal'} pl-5"
>
  {#each data.items as nestedContent}
    <li class="[&>a]:font-medium [&>a]:underline [&>a]:decoration-black/50 dark:[&>a]:decoration-white/50">
      <!-- eslint-disable-next-line -->
      {@html nestedContent.content}
    </li>
  {/each}
</svelte:element>
